var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomefill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9523 5.31531L11.4639 1.60427C9.95202 0.354242 7.82085 0.354242 6.30896 1.60427L1.82058 5.31531C1.01193 5.98391 0.553101 6.99762 0.553101 8.05533V13.8425C0.553101 15.7218 1.99823 17.3334 3.88643 17.3334H5.5531C6.47358 17.3334 7.21977 16.5872 7.21977 15.6667V12.9566C7.21977 11.9003 8.01318 11.1323 8.88643 11.1323C9.75968 11.1323 10.5531 11.9003 10.5531 12.9566V15.6667C10.5531 16.5872 11.2993 17.3334 12.2198 17.3334H13.8864C15.7747 17.3334 17.2198 15.7218 17.2198 13.8425V8.05533C17.2198 6.99763 16.7609 5.98391 15.9523 5.31531Z",
    fill: "#4A4A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomefill);
export default __webpack_public_path__ + "static/media/home.fill.44e278c171c95b462d16f33ded70888d.svg";
export { ForwardRef as ReactComponent };